import { Component, OnInit, OnDestroy, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule} from '@angular/forms';
import { RuleEditorComponent } from "../rule-editor/rule-editor.component";
import { MatAccordion, MatExpansionModule, MatExpansionPanelContent } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import {CdkDragDrop, CdkDropList, CdkDrag} from '@angular/cdk/drag-drop';

import { RulesComponent } from "../rules/rules.component";
import { IComponent, IComponentList, ICreateComponentRequest, ICriteria, IRule } from '@models/measures.model';
import { Store } from '@ngrx/store';
import * as fromMeasures from "@store/selectors/measures/measures.selectors"
import { MeasuresActions} from '@store/actions/measures/measures.actions'
import {  Subscription } from 'rxjs';

@Component({
  selector: 'app-measure-components',
  imports: [
    CommonModule,
    FormsModule,
    RuleEditorComponent,
    MatAccordion,
    MatExpansionModule,
    MatIconModule,
    RulesComponent,
    MatExpansionPanelContent,
    MatSlideToggleModule,
    CdkDropList, 
    CdkDrag
],
  templateUrl: './measure-components.component.html',
  styleUrl: './measure-components.component.css'
})

export class MeasureComponentsComponent implements OnInit, OnDestroy{
 
  @Input() criteriaId: number = 0;
  @Input() components : IComponent[] = [];
    
  private subscription: Subscription = new Subscription();
  private readonly store = inject(Store);

  isShowAllComponents = false;
  criteriaGroupList$ = this.store.select(fromMeasures.selectCriteraiGroupList); 
  componentList:IComponentList[] = []
    

  constructor(){    
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void 
  {
    this.loadCriteriaGroups();
  }

  drop(componentId: number, event: CdkDragDrop<number[]>) {
    this.store.dispatch(MeasuresActions.reorderRuleList({     
      criteriaId: this.criteriaId, componentId: componentId, previous: event.previousIndex, current: event.currentIndex
    }));
  }

  loadCriteriaGroups(){
    this.subscription.add(
      this.criteriaGroupList$.subscribe({
        next: (list) => {
          list.forEach(c =>{
  
            let componentListItem = {
              componentId: this.components.find(comp => comp.criteriaGroupTypeID == c.id )?.id || -1,
              ruleGroupId: this.components.find(comp => comp.criteriaGroupTypeID == c.id )?.ruleGroupId || -1,
              isMandatory: this.setMandatoryFlag(c.id) || (this.components.find(comp => comp.criteriaGroupTypeID == c.id )?.id != null), 
              id: c.id, 
              name: c.name, 
              editorName: `${c.name.toLocaleLowerCase().trim().replace(" ",'-')}-editor`, 
              ruleIdList: this.components.find(comp => comp.criteriaGroupTypeID == c.id )?.rules || [],
              sortOrder: this.components.find(comp => comp.criteriaGroupTypeID == c.id )?.sortOrder || 100
            }
  
            this.componentList.push(componentListItem);
          });          
         }
      })
    );

    this.componentList.sort((a, b) => a.sortOrder - b.sortOrder);

  };

  setMandatoryFlag(id: number): boolean{
    switch(id){
      case 100:
        return true;
      break;
      case 200:
        return true;
      break;
      case 300:
        return false;
      break;
      case 400:
        return true;
      break;
      case 500:
        return false;
      break;
      case 600:
        return false;
      break;
      default:
        return false;
    }
  }

  getEditorId(componentName:string, ruleId: number): string{
    return `${componentName}_${ruleId}`
  }

  createComponent(populationCriteriaGroupID: number, criteriaGroupId :number, criteriaGroupTypeID: number, criteriaName: string){
    
    if(criteriaGroupId != -1)
      return;

    let request : ICreateComponentRequest = {
      criteriaGroupTypeID: criteriaGroupTypeID,
      populationCriteriaGroupID: populationCriteriaGroupID,
      sortOrder: this.componentList.filter( (c: { componentId: number; }) => c.componentId != -1  )?.length + 1,
      createUserID: 1055
    }

   this.store.dispatch(MeasuresActions.addMeasureComponent({ request: request, criteriaName: criteriaName }))
   this.store.dispatch(MeasuresActions.addMeasureComponent({ request: request, criteriaName: criteriaName }))
  }
}

